import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Anchor, Zap, Trophy, Timer, Waves, Sunrise } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function SurfskiPage() {
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-542">
      <Navigation data-id="element-543" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-544">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-545" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png" alt="Surfski Activity" className="w-full h-full object-cover" data-id="element-546" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-547">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-548">
            קיאק Surfski
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-549">
            מהירות, אדרנלין וטכניקה על המים - או סתם חתירה רגועה ונופי הכנרת
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-550">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-551">
          <div data-id="element-552">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-553">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-554">
              ה-Surfski הוא קיאק פתוח, צר וארוך, המיועד לחתירה מהירה ולגלישת
              גלים (Downwind). זהו ספורט המשלב כושר גופני אירובי ברמה גבוהה עם
              מיומנות טכנית של קריאת הים ותפיסת גלים. במועדון שלנו תמצאו את
              הקיאקים הטובים בעולם מבית המותגים המובילים.
            </p>

            {/* Relaxed Paddling Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-2xl p-6 mb-8" data-id="element-555">
              <div className="flex items-start gap-4" data-id="element-556">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-557">
                  <Sunrise className="w-6 h-6 text-blue-500" data-id="element-558" />
                </div>
                <div data-id="element-559">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-560">
                    חתירה רגועה ונופי הכנרת
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-561">
                    לא חייבים להיות ספורטיביים! הקיאק מושלם גם לחתירה רגועה
                    ונינוחה על מי הכנרת השקטים. תיהנו מהשקט, מהנוף המדהים של
                    ההרים מסביב, ומחוויה מדיטטיבית של חיבור לטבע. מתאים במיוחד
                    לזריחות ושקיעות קסומות.
                  </p>
                </div>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-562">
              למי זה מתאים?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-563">
              {['חותרים המחפשים אתגר פיזי ומנטלי', 'אוהבי אדרנלין ומהירות', 'מי שרוצה חתירה רגועה ולהנות מנופי הכנרת', 'מי שרק בא לו להרגע ולהתנתק מהשגרה', 'אנשים עם רקע בחתירה (אך לא חובה, יש קורסי מתחילים)', 'מי שרוצה לשפר את הכושר האירובי בצורה משמעותית'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-564">
                  <div className="bg-indigo-100 p-1 rounded-full" data-id="element-565">
                    <Zap className="w-4 h-4 text-indigo-600" data-id="element-566" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-567">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-568">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-569">
              <div className="flex gap-4" data-id="element-570">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-571">
                  <Anchor className="w-6 h-6 text-indigo-500" data-id="element-572" />
                </div>
                <div data-id="element-573">
                  <h4 className="font-bold text-lg mb-1" data-id="element-574">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-575">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-576">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-577">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-578" />
                </div>
                <div data-id="element-579">
                  <h4 className="font-bold text-lg mb-1" data-id="element-580">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-581">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-582">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-583">
                  <Zap className="w-6 h-6 text-indigo-500" data-id="element-584" />
                </div>
                <div data-id="element-585">
                  <h4 className="font-bold text-lg mb-1" data-id="element-586">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-587">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-588">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-589">
                  <Trophy className="w-6 h-6 text-indigo-500" data-id="element-590" />
                </div>
                <div data-id="element-591">
                  <h4 className="font-bold text-lg mb-1" data-id="element-592">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-593">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-594">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-595">
                  <Timer className="w-6 h-6 text-indigo-500" data-id="element-596" />
                </div>
                <div data-id="element-597">
                  <h4 className="font-bold text-lg mb-1" data-id="element-598">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-599">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-600">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-601">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-602" />
                </div>
                <div data-id="element-603">
                  <h4 className="font-bold text-lg mb-1" data-id="element-604">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-605">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-606">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-607">
                הצטרפו לאימון ניסיון
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-608" />
      <Footer data-id="element-609" />
    </div>;
}